import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  MenuItem,
  IconButton,
  Typography,
  InputAdornment,
  makeStyles,
} from "@material-ui/core";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { format, addDays, isBefore } from "date-fns";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import { fetchTeamAssociates } from "../../../../containers/actions/common/teamMemberAction";
import CustomDatePickerMui from "../../models/inputs/DateInput";
import {
  dateFormated,
  presentFormatedData,
} from "../../functionalComponents/dataFormatFunctions";
import EditIcon from "@material-ui/icons/Edit";
import { useDispatch, useSelector } from "react-redux";
// import SaveIcon from '@material-ui/icons/Save';
// import ClearIcon from '@material-ui/icons/Clear';

// const initialData = [
//   {
//     id: 1,
//     task: "Date and qty. confirmation",
//     responder: "Hannah Keys",
//     department: "Resilient - SC - manager",
//     date: "06-MAR-2025",
//   },
//   {
//     id: 2,
//     task: "Lot allocation",
//     responder: "Eddie Wyatt",
//     department: "Treetops - project management - planner",
//     date: "10-MAR-2025",
//   },
//   {
//     id: 3,
//     task: "Artwork confirmation",
//     responder: "Anna Luo",
//     department: "Resilient - AW - manager",
//     date: "17-MAR-2025",
//   },
// ];

const initialData = [
  {
    id: 1,
    task: "Date and qty. confirmation",
    responder: "Hannah Keys",
    organization: "Resilient",
    department: "SC",
    role: "manager",
    date: "06-MAR-2025",
  },
  {
    id: 2,
    task: "Batch allocation",
    responder: "Eddie Wyatt",
    organization: "Treetops",
    department: "project management",
    role: "planner",
    date: "10-MAR-2025",
  },
  {
    id: 3,
    task: "Artwork confirmation",
    responder: "Anna Luo",
    organization: "Resilient",
    department: "AW",
    role: "manager",
    date: "17-MAR-2025",
  },
];

const departments = [
  { organization: "Resilient", department: "SC", role: "manager" },
  {
    organization: "Treetops",
    department: "project management",
    role: "planner",
  },
  { organization: "Resilient", department: "AW", role: "manager" },
];

const tasks = ["Quality Check", "Material Inspection", "Report Generation", "Stock Update"];


const respondersList = ["Hannah Keys", "Eddie Wyatt", "Anna Luo"];
// const departments = [
//   "Resilient - SC - manager",
//   "Treetops - project management - planner",
//   "Resilient - AW - manager",
// ];

const organizationData = [
  {
    organization: "ABC Healthcare",
    department: "Oncology",
    role: "Main Oncologist",
    teamMember: "John Doe",
    email: "john.doe@abchealthcare.com",
  },
  {
    organization: "XYZ Pharmaceuticals",
    department: "Research & Development",
    role: "Senior Scientist",
    teamMember: "Jane Smith",
    email: "jane.smith@xyzpharma.com",
  },
  {
    organization: "MediCare Group",
    department: "Cardiology",
    role: "Consultant",
    teamMember: "Robert Brown",
    email: "robert.brown@medicare.com",
  },
  {
    organization: "LifeLine Hospitals",
    department: "Neurology",
    role: "Neurosurgeon",
    teamMember: "Emily Davis",
    email: "emily.davis@lifeline.com",
  },
  {
    organization: "Global Health",
    department: "Pediatrics",
    role: "Pediatrician",
    teamMember: "Michael Johnson",
    email: "michael.johnson@globalhealth.com",
  },
];


const useStyles = makeStyles((theme) => ({
   addButton: {
    backgroundColor: "white",
    color:"balck",
    "&:hover": {
      backgroundColor: "Black",
      color: "white",
    },
  },

}));

const EditResponsibleRespond = (props) => {
  const dispatch = useDispatch();
  const { data } = props;
  const classes = useStyles();
  // const [respondersList, setRespondersList] = useState([]);
  // const [selectedDepartments, setSelectedDepartments] = useState({});
  const [selectedResponders, setSelectedResponders] = useState({});
const [selectedDetails, setSelectedDetails] = useState({});
  // const [selectedResponders, setSelectedResponders] = useState({});
  const [selectedTasks, setSelectedTasks] = useState({});
  const [rows, setRows] = useState(initialData);
  // const [selectedDepartments, setSelectedDepartments] = useState({});

    const teamMembersList = useSelector((state) => {
      return state?.pcmp?.common?.teamMembers?.teamMembersDetails?.data;
    });

    console.log("teamMembersList",teamMembersList)

      useEffect(() => {
        // dispatch({
        //   type: FETCH_TEAM_ASSOCIATES_LOADING,
        //   payload: true,
        // });
        dispatch(
          fetchTeamAssociates({
            departmentID: 0,
            collaborator_role_id: 0,
            searchString: "all",
            status: "Active",
          })
        );
      }, []);

  const addRow = () => {
    const newDate = format(addDays(new Date(), 7), "dd-MMM-yyyy").toUpperCase();
    setRows([
      ...rows,
      {
        id: rows.length + 1,
        task: "",
        responder: "",
        department: "",
        date: newDate,
        editable: true,
      },
    ]);
  };

// // Function to extract responder names
// const getRespondersList = () => {
//   return teamMembersList.map((member) => member.full_name);
// };

// // Function to get department and role based on selected full_name
// const getDepartmentRole = (fullName) => {
//   const selectedMember = teamMembersList.find(
//     (member) => member.full_name === fullName
//   );
//   return selectedMember
//     ? {
//         department: selectedMember.department_name || "N/A",
//         role: selectedMember.roleName || "N/A",
//       }
//     : { department: "N/A", role: "N/A" };
// };

// useEffect(() => {
//   setRespondersList(getRespondersList());
// }, []);

// const handleResponderChange = (rowId, selectedResponder) => {
//   handleChange(rowId, "responder", selectedResponder);
//   const { department, role } = getDepartmentRole(selectedResponder);
//   setSelectedDepartments((prev) => ({
//     ...prev,
//     [rowId]: { department, role },
//   }));
// };


const updateResponderSelection = (rowId, responderName) => {
  const selectedMember = teamMembersList.find(
    (member) => member.full_name === responderName
  );

  setSelectedResponders((prev) => ({
    ...prev,
    [rowId]: responderName,
  }));

  if (selectedMember) {
    setSelectedDetails((prev) => ({
      ...prev,
      [rowId]: {
        department: selectedMember.department_name || "",
        role: selectedMember.roleName || "",
      },
    }));
  }
};

  // const handleChange = (id, field, value) => {
  //   setRows(rows.map(row => (row.id === id ? { ...row, [field]: value } : row)));
  // };

  // const handleChange = (id, field, value) => {
  //   setRows(
  //     rows.map((row) => {
  //       if (row.id === id) {
  //         if (field === "date" && isBefore(new Date(value), new Date())) {
  //           return row;
  //         }
  //         return { ...row, [field]: value };
  //       }
  //       return row;
  //     })
  //   );
  // };

  const updateSelectedTask = (id, value) => {
    setSelectedTasks((prev) => ({
      ...prev,
      [id]: value, // Store selected task per row ID
    }));
  };
  

  const handleChange = (id, field, value) => {
    if (field === "department") {
      const [organization, department, role] = value.split(" - ");
      
      // setSelectedDepartments((prev) => ({
      //   ...prev,
      //   [id]: { organization, department, role },
      // }));
  
      setRows((prevRows) =>
        prevRows.map((row) =>
          row.id === id ? { ...row, organization, department, role } : row
        )
      );
    } 
    // else if (field === "date") {
    //   setRows((prevRows) =>
    //     prevRows.map((row) =>
    //       row.id === id && !isBefore(
    //         new Date(value),
    //         new Date()
    //   )
    //         ? { ...row, date: value }
    //         : row
    //     )
    //   );
    // }

    else if (field === "responder") {
      setSelectedResponders((prev) => ({ ...prev, [id]: value }));

      setRows((prevRows) =>
        prevRows.map((row) =>
          row.id === id ? { ...row, responder: value } : row
        )
      );
    }
    else if (field === "date") {
      const selectedDate = new Date(value);
      const today = new Date();
    
      // Normalize both dates to midnight (00:00:00) for accurate comparison
      selectedDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
    
      if (selectedDate >= today) {
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === id ? { ...row, date: value } : row
          )
        );
      }
    }
    
  };
  

  const deleteRow = (id) => {
    setRows(rows.filter((row) => row.id !== id));
  };

  return (
    <div>
      {/* {localStorage.collabType !== "CMO" ? 
                  edit
                  ?
                  <Box style={{display:'flex', alignItems:'center', gap:'10px'}}>
            <TextField
              select
              value={selectedMember}
              onChange={(e) => setSelectedMember(e.target.value)}
              variant="outlined"
              size="small"
              style={{ width: "150px" }}
            >
              {organizationData.map((item, index) => (
                <MenuItem key={index} value={item.teamMember}>
                  {item.teamMember}
                </MenuItem>
              ))}
             
              <MenuItem value="Add Others">Add Others</MenuItem>
            </TextField>
                      <Box style={{ display: 'flex', flexDirection: 'column', gap:'3px' }}>
                          <span title='save'><SaveIcon style={{ cursor: 'pointer', fontSize: 'small' }} /></span>
                          <span title='clear'><ClearIcon onClick={handleClear} style={{cursor:'pointer',fontSize:'small'}} /></span>
                  </Box>
        </Box>
      :
                  <>
                      <Box style={{display:'flex', alignItems:'center', gap:'10px'}}>
                          {presentFormatedData(row?.SLDetails?.responsibleToRespond || 'NA')}
                  <Box style={{ display: 'flex', flexDirection: 'column', gap:'3px' }}>
                      <span title='Edit'><EditIcon onClick={()=>setEdit(true)} style={{cursor:'pointer',fontSize:'small'}} /></span>
                  </Box>
              </Box>
                  </>
              
              :
              <>
                  {presentFormatedData(row?.SLDetails?.responsibleToRespond || 'NA')}
              </>
          } */}

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead style={{backgroundColor: "#f8f8f8",paddingTop:'1px',paddingBottom:"1px"}}>
            <TableRow>
              <TableCell>Tasks to be performed</TableCell>
              <TableCell>Responsible to respond</TableCell>
              <TableCell>Organization department - role</TableCell>
              <TableCell>Respond by date</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
                {/* <TableCell>
                  {row.editable ? (
                    <TextField
                      variant="outlined"
                      size="small"
                      value={row.task}
                      onChange={(e) =>
                        handleChange(row.id, "task", e.target.value)
                      }
                      fullWidth
                    />
                  ) : (
                    row.task
                  )}
                </TableCell> */}
<TableCell>
  {row.editable ? (
    <TextField
      variant="outlined"
      size="small"
      select
      value={selectedTasks[row.id] || row.task} // Show selected task or default task
      onChange={(e) => updateSelectedTask(row.id, e.target.value)}
      fullWidth
    >
      {tasks.map((task, index) => (
        <MenuItem key={index} value={task}>
          {task}
        </MenuItem>
      ))}
    </TextField>
  ) : (
    selectedTasks[row.id] || row.task
  )}
</TableCell>


                {/* <TableCell>
                  {row.editable ? (
                    <TextField
                      select
                      variant="outlined"
                      size="small"
                      value={row.responder}
                      onChange={(e) =>
                        handleChange(row.id, "responder", e.target.value)
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      fullWidth
                    >
              {respondersList.map((responder) => (
                <MenuItem key={responder} value={responder}>
                  {responder}
                </MenuItem>
              ))}
                    </TextField>
                  ) : (
                    row.responder
                  )}
                </TableCell>
               
                <TableCell>
  {row.editable ? (
    <TextField
      variant="outlined"
      size="small"
      select
      value={
        selectedDepartments[row.id]
          ? `${selectedDepartments[row.id].organization} - ${selectedDepartments[row.id].department} - ${selectedDepartments[row.id].role}`
          : `${row.organization} - ${row.department} - ${row.role}`
      }
      onChange={(e) => handleChange(row.id, "department", e.target.value)}
      fullWidth
    >
      {departments.map((dept) => (
        <MenuItem
          key={`${dept.organization}-${dept.department}-${dept.role}`}
          value={`${dept.organization} - ${dept.department} - ${dept.role}`}
        >
          {`${dept.organization} - ${dept.department} - ${dept.role}`}
        </MenuItem>
      ))}
    </TextField>
  ) : (
    `${row.organization} - ${row.department} - ${row.role}`
  )}
</TableCell> */}

<TableCell>
  {row.editable ? (
    <TextField
      select
      variant="outlined"
      size="small"
      value={selectedResponders[row.id] || ""}
      onChange={(e) => updateResponderSelection(row.id, e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      fullWidth
    >
      {teamMembersList.map((member) => (
        <MenuItem key={member.saas_user_id || member.temp_ecosystem_collab_id} value={member.full_name}>
          {member.full_name}
        </MenuItem>
      ))}
    </TextField>
  ) : (
    row.responder
  )}
</TableCell>

{/* <TableCell>
  {row.editable ? (
    <TextField
      variant="outlined"
      size="small"
      value={
        selectedDetails[row.id]
          ? `${selectedDetails[row.id].department} - ${selectedDetails[row.id].role}`
          : `${row.department} - ${row.role}`
      }
      fullWidth
      disabled
    />
  ) : (
    `${row.department} - ${row.role}`
  )}
</TableCell> */}


<TableCell>
  {selectedDetails[row.id] ? (
    <Typography variant="body2" style={{ color: "black" }}>
      {selectedDetails[row.id].department} - {selectedDetails[row.id].role}
    </Typography>
  ) : (
    <Typography variant="body2" style={{ color: "black" }}>
      {row.editable ? "" : row.department && row.role ? `${row.department} - ${row.role}` : ""}
    </Typography>
  )}
</TableCell>

                <TableCell>
                  {row.editable ? (
                    <TextField
                      type="date"
                      size="small"
                      variant="outlined"
                      value={format(new Date(row.date), "yyyy-MM-dd")}
                      onChange={(e) =>
                        handleChange(row.id, "date", e.target.value)
                      }
                      fullWidth
                      inputProps={{ min: format(new Date(), "yyyy-MM-dd") }}
                    />
                  ) : (
                    <Typography style={{ color: "black", padding: "8px 0" }}>
                      {format(new Date(row.date), "dd-MMM-yyyy")}
                    </Typography>
                  )}
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <IconButton
                    style={{
                      border: "1px solid black",
                      borderRadius: "4px", // Makes it rectangular
                      padding: "2px 16px", // Adjusts padding for a better shape
                      display: "flex",
                      alignItems: "center",
                      gap: "8px", // Adds spacing between icon & text
                    }}
                  >
                    <AutorenewIcon
                      fontSize="small"
                      style={{ color: "black" }}
                    />
                    <Typography style={{ color: "black" }}>
                      Send Reminder
                    </Typography>
                  </IconButton>
                  <IconButton onClick={() => deleteRow(row.id)}>
                    <DeleteOutlinedIcon style={{ color: "red" }} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {/* <Button
          onClick={addRow}
          variant="contained"
          color="primary"
          style={{ margin: 16 }}
        >
          Add new row
        </Button> */}
            <Button
            className={classes.addButton}
      onClick={addRow}
      variant="outlined" // Outlined to show black border
      style={{
        // color: "black",
        border: "1px solid black",
        borderRadius:"20rem",
        margin: 16,
        textTransform: "none", // Keeps text case as is
      }}
      startIcon={
        <div
          style={{
            width:17,
            height:17,
            borderRadius: "50%", // Makes the icon circular
            border: "1px solid black",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <AddIcon style={{ fontSize: 16}} />
        </div>
      }
    >
      Add New Row
    </Button>
      </TableContainer>
    </div>
  );
};

export default EditResponsibleRespond;
